export const SUNDAY = { value: 0, text: 'Sunday' }
export const MONDAY = { value: 1, text: 'Monday' }
export const TUESDAY = { value: 2, text: 'Tuesday' }
export const WEDNESDAY = { value: 3, text: 'Wednesday' }
export const THURSDAY = { value: 4, text: 'Thursday' }
export const FRIDAY = { value: 5, text: 'Friday' }
export const SATURDAY = { value: 6, text: 'Saturday' }
